import "@/App.css";
import { lazy, Suspense } from "react";
// HomePage stays eager; all other routes are lazy chunks.
import HomePage from "@/pages/HomePage";
// Calculator/Guide pages split out so the homepage bundle skips guide metadata,
// Q&A data, results views, and embed widgets (~600KB raw).
const CalculatorPage = lazy(() => import("@/pages/CalculatorPage"));
const GuidePage = lazy(() => import("@/pages/GuidePage"));
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
const StateCalculatorPage = lazy(() => import("@/pages/StateCalculatorPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const PrivacyPolicyPage = lazy(() => import("@/pages/PrivacyPolicyPage"));
const TermsOfServicePage = lazy(() => import("@/pages/TermsOfServicePage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const ForContractorsPage = lazy(() => import("@/pages/ForContractorsPage"));
const GuidesIndexPage = lazy(() => import("@/pages/GuidesIndexPage"));
const SitemapPage = lazy(() => import("@/pages/SitemapPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));
const WhyExpensivePage = lazy(() => import("@/pages/WhyExpensivePage"));
const WhyExpensiveHubPage = lazy(() => import("@/pages/WhyExpensiveHubPage"));
const PressKitPage = lazy(() => import("@/pages/PressKitPage"));
const EmbedCostIndexPage = lazy(() => import("@/pages/EmbedCostIndexPage"));
const EmbedStormDamageCalculatorPage = lazy(() => import("@/pages/EmbedStormDamageCalculatorPage"));
const EmbedDiyOrContractorCalculatorPage = lazy(() => import("@/pages/EmbedDiyOrContractorCalculatorPage"));
const EmbedRepairOrReplaceCalculatorPage = lazy(() => import("@/pages/EmbedRepairOrReplaceCalculatorPage"));
const EmbedRenovationFinancingCalculatorPage = lazy(() => import("@/pages/EmbedRenovationFinancingCalculatorPage"));
const EmbedQuoteFairnessCalculatorPage = lazy(() => import("@/pages/EmbedQuoteFairnessCalculatorPage"));
const EmbedPreListingSpendCalculatorPage = lazy(() => import("@/pages/EmbedPreListingSpendCalculatorPage"));
const EmbedContractorDisputeCalculatorPage = lazy(() => import("@/pages/EmbedContractorDisputeCalculatorPage"));
const EmbedBasementFinishCalculatorPage = lazy(() => import("@/pages/EmbedBasementFinishCalculatorPage"));
const EmbedDwellingCoverageCalculatorPage = lazy(() => import("@/pages/EmbedDwellingCoverageCalculatorPage"));
const EmbedsIndexPage = lazy(() => import("@/pages/EmbedsIndexPage"));
const EmbedWidgetLandingPage = lazy(() => import("@/pages/EmbedWidgetLandingPage"));
const EnergyEfficiencyBundlePage = lazy(() => import("@/pages/EnergyEfficiencyBundlePage"));
const StormRecoveryBundlePage = lazy(() => import("@/pages/StormRecoveryBundlePage"));
const PreListingRenovationBundlePage = lazy(() => import("@/pages/PreListingRenovationBundlePage"));
const OutdoorLivingBundlePage = lazy(() => import("@/pages/OutdoorLivingBundlePage"));
const EmbedsInstalledOnPage = lazy(() => import("@/pages/EmbedsInstalledOnPage"));
const QuoteFairnessStateProjectPage = lazy(() => import("@/pages/QuoteFairnessStateProjectPage"));
const LicensePage = lazy(() => import("@/pages/LicensePage"));
const FeaturedInPage = lazy(() => import("@/pages/FeaturedInPage"));
const MetroPricingPage = lazy(() => import("@/pages/MetroPricingPage"));
const MethodologyPage = lazy(() => import("@/pages/MethodologyPage"));
const EditorialStandardsPage = lazy(() => import("@/pages/EditorialStandardsPage"));
const FlooringAtlasPage = lazy(() => import("@/pages/FlooringAtlasPage"));
const FlooringAtlasCheapestPage = lazy(() => import("@/pages/FlooringAtlasCheapestPage"));
const FlooringAtlasRoiPage = lazy(() => import("@/pages/FlooringAtlasRoiPage"));
const FlooringAtlasDiyPage = lazy(() => import("@/pages/FlooringAtlasDiyPage"));
const FlooringAtlasQuickResalePage = lazy(() => import("@/pages/FlooringAtlasQuickResalePage"));
const DeckAtlasPage = lazy(() => import("@/pages/DeckAtlasPage"));
const DeckAtlasCheapestPage = lazy(() => import("@/pages/DeckAtlasCheapestPage"));
const DeckAtlasRoiPage = lazy(() => import("@/pages/DeckAtlasRoiPage"));
const DeckAtlasDiyPage = lazy(() => import("@/pages/DeckAtlasDiyPage"));
const DeckAtlasQuickResalePage = lazy(() => import("@/pages/DeckAtlasQuickResalePage"));
const BasementAtlasPage = lazy(() => import("@/pages/BasementAtlasPage"));
const BasementAtlasCheapestPage = lazy(() => import("@/pages/BasementAtlasCheapestPage"));
const BasementAtlasRoiPage = lazy(() => import("@/pages/BasementAtlasRoiPage"));
const BasementAtlasDiyPage = lazy(() => import("@/pages/BasementAtlasDiyPage"));
const BasementAtlasQuickResalePage = lazy(() => import("@/pages/BasementAtlasQuickResalePage"));
const PoolAtlasPage = lazy(() => import("@/pages/PoolAtlasPage"));
const PoolAtlasCheapestPage = lazy(() => import("@/pages/PoolAtlasCheapestPage"));
const PoolAtlasRoiPage = lazy(() => import("@/pages/PoolAtlasRoiPage"));
const PoolAtlasDiyPage = lazy(() => import("@/pages/PoolAtlasDiyPage"));
const PoolAtlasQuickResalePage = lazy(() => import("@/pages/PoolAtlasQuickResalePage"));
const KitchenAtlasPage = lazy(() => import("@/pages/KitchenAtlasPage"));
const KitchenAtlasCheapestPage = lazy(() => import("@/pages/KitchenAtlasCheapestPage"));
const KitchenAtlasRoiPage = lazy(() => import("@/pages/KitchenAtlasRoiPage"));
const KitchenAtlasDiyPage = lazy(() => import("@/pages/KitchenAtlasDiyPage"));
const KitchenAtlasQuickResalePage = lazy(() => import("@/pages/KitchenAtlasQuickResalePage"));
const BathroomAtlasPage = lazy(() => import("@/pages/BathroomAtlasPage"));
const BathroomAtlasCheapestPage = lazy(() => import("@/pages/BathroomAtlasCheapestPage"));
const BathroomAtlasRoiPage = lazy(() => import("@/pages/BathroomAtlasRoiPage"));
const BathroomAtlasDiyPage = lazy(() => import("@/pages/BathroomAtlasDiyPage"));
const BathroomAtlasQuickResalePage = lazy(() => import("@/pages/BathroomAtlasQuickResalePage"));
const HardscapeAtlasPage = lazy(() => import("@/pages/HardscapeAtlasPage"));
const HardscapeAtlasCheapestPage = lazy(() => import("@/pages/HardscapeAtlasCheapestPage"));
const HardscapeAtlasRoiPage = lazy(() => import("@/pages/HardscapeAtlasRoiPage"));
const HardscapeAtlasDiyPage = lazy(() => import("@/pages/HardscapeAtlasDiyPage"));
const HardscapeAtlasQuickResalePage = lazy(() => import("@/pages/HardscapeAtlasQuickResalePage"));
const LandscapeAtlasPage = lazy(() => import("@/pages/LandscapeAtlasPage"));
const LandscapeAtlasCheapestPage = lazy(() => import("@/pages/LandscapeAtlasCheapestPage"));
const LandscapeAtlasRoiPage = lazy(() => import("@/pages/LandscapeAtlasRoiPage"));
const LandscapeAtlasDiyPage = lazy(() => import("@/pages/LandscapeAtlasDiyPage"));
const LandscapeAtlasQuickResalePage = lazy(() => import("@/pages/LandscapeAtlasQuickResalePage"));
const OutdoorLivingByStatePage = lazy(() => import("@/pages/OutdoorLivingByStatePage"));
const OutdoorRenovationEstimatorPage = lazy(() => import("@/pages/OutdoorRenovationEstimatorPage"));
const IndoorRenovationEstimatorPage = lazy(() => import("@/pages/IndoorRenovationEstimatorPage"));
const TrendingPage = lazy(() => import("@/pages/TrendingPage"));
const TrendingSnapshotIndexPage = lazy(() => import("@/pages/TrendingSnapshotIndexPage"));
const TrendingSnapshotPage = lazy(() => import("@/pages/TrendingSnapshotPage"));
const StateWindowGalleryPage = lazy(() => import("@/pages/StateWindowGalleryPage"));
const CalculatorsIndexPage = lazy(() => import("@/pages/CalculatorsIndexPage"));
const AnswersPage = lazy(() => import("@/pages/AnswersPage"));
const AnswersCalcHubPage = lazy(() => import("@/pages/AnswersCalcHubPage"));
const DatasetPage = lazy(() => import("@/pages/DatasetPage"));
const ApiPage = lazy(() => import("@/pages/ApiPage"));
const StormRecoveryPage = lazy(() => import("@/pages/StormRecoveryPage"));
const StormDamageClaimCalculatorPage = lazy(() => import("@/pages/StormDamageClaimCalculatorPage"));
const RoofRepairOrReplaceCalculatorPage = lazy(() => import("@/pages/RoofRepairOrReplaceCalculatorPage"));
const RenovateOrMoveCalculatorPage = lazy(() => import("@/pages/RenovateOrMoveCalculatorPage"));
const RoofClaimCalculatorPage = lazy(() => import("@/pages/RoofClaimCalculatorPage"));
const DwellingCoverageCalculatorPage = lazy(() => import("@/pages/DwellingCoverageCalculatorPage"));
const DiyOrContractorCalculatorPage = lazy(() => import("@/pages/DiyOrContractorCalculatorPage"));
const RenovationRoiCalculatorPage = lazy(() => import("@/pages/RenovationRoiCalculatorPage"));
const RenovationFinancingCalculatorPage = lazy(() => import("@/pages/RenovationFinancingCalculatorPage"));
const HomeEquityLoanCalculatorPage = lazy(() => import("@/pages/HomeEquityLoanCalculatorPage"));
const HomeEquityLoanStatePage = lazy(() => import("@/pages/HomeEquityLoanStatePage"));
const QuoteFairnessCalculatorPage = lazy(() => import("@/pages/QuoteFairnessCalculatorPage"));
const QuoteComparisonPage = lazy(() => import("@/pages/QuoteComparisonPage"));
const ContractorDisputeCalculatorPage = lazy(() => import("@/pages/ContractorDisputeCalculatorPage"));
const BasementFinishCalculatorPage = lazy(() => import("@/pages/BasementFinishCalculatorPage"));
const SolarReadinessCalculatorPage = lazy(() => import("@/pages/SolarReadinessCalculatorPage"));
const RebateLookupPage = lazy(() => import("@/pages/RebateLookupPage"));
const ToolsIndexPage = lazy(() => import("@/pages/ToolsIndexPage"));
const ComfortUpgradeEstimatorPage = lazy(() => import("@/pages/ComfortUpgradeEstimatorPage"));
const StateRebatePage = lazy(() => import("@/pages/StateRebatePage"));
const BasementFinishRoiHubPage = lazy(() => import("@/pages/BasementFinishRoiHubPage"));
const BasementFinishRoiStateProjectPage = lazy(() => import("@/pages/BasementFinishRoiStateProjectPage"));
const BasementFinishRoiStateAggregatorPage = lazy(() => import("@/pages/BasementFinishRoiStateAggregatorPage"));
const LowPermitStatesPage = lazy(() => import("@/pages/LowPermitStatesPage"));
const BestRoiBasementFinishStatesPage = lazy(() => import("@/pages/BestRoiBasementFinishStatesPage"));
const BestRoiRenovationsByStatePage = lazy(() => import("@/pages/BestRoiRenovationsByStatePage"));
const DecisionToolsHubPage = lazy(() => import("@/pages/DecisionToolsHubPage"));
const RenovationTimelineHubPage = lazy(() => import("@/pages/RenovationTimelineHubPage"));
const RenovationTimelineStateProjectPage = lazy(() => import("@/pages/RenovationTimelineStateProjectPage"));
const ContractorLicensingHubPage = lazy(() => import("@/pages/ContractorLicensingHubPage"));
const ContractorLicensingStateProjectPage = lazy(() => import("@/pages/ContractorLicensingStateProjectPage"));
const ContractorDepositRulesHubPage = lazy(() => import("@/pages/ContractorDepositRulesHubPage"));
const ContractorDepositRulesStateProjectPage = lazy(() => import("@/pages/ContractorDepositRulesStateProjectPage"));
const EnergyRebatesHubPage = lazy(() => import("@/pages/EnergyRebatesHubPage"));
const EnergyRebatesStateProjectPage = lazy(() => import("@/pages/EnergyRebatesStateProjectPage"));
const PermitCostHubPage = lazy(() => import("@/pages/PermitCostHubPage"));
const PermitCostStateProjectPage = lazy(() => import("@/pages/PermitCostStateProjectPage"));
const StateOverviewHubPage = lazy(() => import("@/pages/StateOverviewHubPage"));
const StateOverviewPage = lazy(() => import("@/pages/StateOverviewPage"));
const HeehraAdminPage = lazy(() => import("@/pages/HeehraAdminPage"));
const EmbedCalculatorPage = lazy(() => import("@/pages/EmbedCalculatorPage"));
const QaIndexPage = lazy(() => import("@/pages/QaPage").then(m => ({ default: m.default })));
const QaSinglePage = lazy(() => import("@/pages/QaPage").then(m => ({ default: m.QaSinglePage })));
const BestOf2026Page = lazy(() => import("@/pages/BestOf2026Page"));
const RoiShowdownPage = lazy(() => import("@/pages/RoiShowdownPage"));
const PreBidScopeChecklistPage = lazy(() => import("@/pages/PreBidScopeChecklistPage"));
const PreListingSpendCalculatorPage = lazy(() => import("@/pages/PreListingSpendCalculatorPage"));
const WhatsNewPage = lazy(() => import("@/pages/WhatsNewPage"));
import { CALCULATOR_LIST, getStateLandingUrl } from "@/lib/calculators";
import { US_STATES } from "@/lib/states";

// 13 × 50 = 650 programmatic state landing pages.
const STATE_ROUTES = CALCULATOR_LIST.flatMap((calc) =>
  US_STATES.map((state) => ({
    path: getStateLandingUrl(calc, state.slug),
    slug: calc.slug,
    stateCode: state.code,
  }))
);

// 50 "Why is X renovation expensive?" cost-driver pages (one per state).
const WHY_EXPENSIVE_ROUTES = US_STATES.map((state) => ({
  path: `/why-is-${state.slug}-renovation-expensive`,
  slug: state.slug,
}));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">Loading…</div>}>
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/calculators" element={<CalculatorsIndexPage />} />
            <Route path="/bathroom-remodel-cost-calculator" element={<CalculatorPage slug="bathroom" />} />
            <Route path="/kitchen-remodel-cost-calculator" element={<CalculatorPage slug="kitchen" />} />
            <Route path="/flooring-cost-calculator" element={<CalculatorPage slug="flooring" />} />
            <Route path="/roofing-cost-calculator" element={<CalculatorPage slug="roofing" />} />
            <Route path="/deck-cost-calculator" element={<CalculatorPage slug="deck" />} />
            <Route path="/basement-finishing-cost-calculator" element={<CalculatorPage slug="basement" />} />
            <Route path="/window-replacement-cost-calculator" element={<CalculatorPage slug="windows" />} />
            <Route path="/solar-panel-cost-calculator" element={<CalculatorPage slug="solar" />} />
            <Route path="/fence-installation-cost-calculator" element={<CalculatorPage slug="fence" />} />
            <Route path="/pool-installation-cost-calculator" element={<CalculatorPage slug="pool" />} />
            <Route path="/painting-cost-calculator" element={<CalculatorPage slug="painting" />} />
            <Route path="/hardscape-cost-calculator" element={<CalculatorPage slug="hardscape" />} />
            <Route path="/landscaping-cost-calculator" element={<CalculatorPage slug="landscaping" />} />
            <Route path="/door-replacement-cost-calculator" element={<CalculatorPage slug="door" />} />
            <Route path="/hvac-cost-calculator" element={<CalculatorPage slug="hvac" />} />
            <Route path="/furnace-cost-calculator" element={<CalculatorPage slug="furnace" />} />
            <Route path="/insulation-cost-calculator" element={<CalculatorPage slug="insulation" />} />

            {STATE_ROUTES.map((r) => (
              <Route
                key={r.path}
                path={r.path}
                element={<StateCalculatorPage slug={r.slug} stateCode={r.stateCode} />}
              />
            ))}

            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/methodology" element={<MethodologyPage />} />
            <Route path="/editorial-standards" element={<EditorialStandardsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/for-contractors" element={<ForContractorsPage />} />
            <Route path="/guides" element={<GuidesIndexPage />} />
            <Route path="/guides/:slug" element={<GuidePage />} />
            <Route path="/sitemap" element={<SitemapPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/why-renovation-is-expensive" element={<WhyExpensiveHubPage />} />
            <Route path="/press" element={<PressKitPage />} />
            <Route path="/license" element={<LicensePage />} />
            <Route path="/featured-in" element={<FeaturedInPage />} />
            <Route path="/metro-pricing" element={<MetroPricingPage />} />
            <Route path="/flooring-cost-by-state" element={<FlooringAtlasPage />} />
            <Route
              path="/flooring-cost-by-state/cheapest-for-first-time-buyers"
              element={<FlooringAtlasCheapestPage />}
            />
            <Route
              path="/flooring-cost-by-state/best-roi-by-state"
              element={<FlooringAtlasRoiPage />}
            />
            <Route
              path="/flooring-cost-by-state/best-diy-friendly-states"
              element={<FlooringAtlasDiyPage />}
            />
            <Route
              path="/flooring-cost-by-state/quick-resale-picks-by-region"
              element={<FlooringAtlasQuickResalePage />}
            />
            {/* Deck atlas — same playbook as the flooring atlas. Hub +
                4 variant pages (cheapest, ROI, DIY-friendly, quick-resale). */}
            <Route path="/deck-cost-by-state" element={<DeckAtlasPage />} />
            <Route
              path="/deck-cost-by-state/cheapest-for-first-time-buyers"
              element={<DeckAtlasCheapestPage />}
            />
            <Route
              path="/deck-cost-by-state/best-roi-by-state"
              element={<DeckAtlasRoiPage />}
            />
            <Route
              path="/deck-cost-by-state/best-diy-friendly-states"
              element={<DeckAtlasDiyPage />}
            />
            <Route
              path="/deck-cost-by-state/quick-resale-picks-by-region"
              element={<DeckAtlasQuickResalePage />}
            />
            {/* Basement atlas — same playbook as deck. Hub + 4 variants. */}
            <Route path="/basement-cost-by-state" element={<BasementAtlasPage />} />
            <Route
              path="/basement-cost-by-state/cheapest-for-first-time-buyers"
              element={<BasementAtlasCheapestPage />}
            />
            <Route
              path="/basement-cost-by-state/best-roi-by-state"
              element={<BasementAtlasRoiPage />}
            />
            <Route
              path="/basement-cost-by-state/best-diy-friendly-states"
              element={<BasementAtlasDiyPage />}
            />
            <Route
              path="/basement-cost-by-state/quick-resale-picks-by-region"
              element={<BasementAtlasQuickResalePage />}
            />
            {/* Pool atlas — same playbook. Hub + 4 variants. */}
            <Route path="/pool-cost-by-state" element={<PoolAtlasPage />} />
            <Route
              path="/pool-cost-by-state/cheapest-for-first-time-buyers"
              element={<PoolAtlasCheapestPage />}
            />
            <Route
              path="/pool-cost-by-state/best-roi-by-state"
              element={<PoolAtlasRoiPage />}
            />
            <Route
              path="/pool-cost-by-state/best-diy-friendly-states"
              element={<PoolAtlasDiyPage />}
            />
            <Route
              path="/pool-cost-by-state/quick-resale-picks-by-region"
              element={<PoolAtlasQuickResalePage />}
            />
            {/* Kitchen + Bathroom atlases — hub + 4 variants each. */}
            <Route path="/kitchen-cost-by-state" element={<KitchenAtlasPage />} />
            <Route
              path="/kitchen-cost-by-state/cheapest-for-first-time-buyers"
              element={<KitchenAtlasCheapestPage />}
            />
            <Route
              path="/kitchen-cost-by-state/best-roi-by-state"
              element={<KitchenAtlasRoiPage />}
            />
            <Route
              path="/kitchen-cost-by-state/best-diy-friendly-states"
              element={<KitchenAtlasDiyPage />}
            />
            <Route
              path="/kitchen-cost-by-state/quick-resale-picks-by-region"
              element={<KitchenAtlasQuickResalePage />}
            />
            <Route path="/bathroom-cost-by-state" element={<BathroomAtlasPage />} />
            <Route
              path="/bathroom-cost-by-state/cheapest-for-first-time-buyers"
              element={<BathroomAtlasCheapestPage />}
            />
            <Route
              path="/bathroom-cost-by-state/best-roi-by-state"
              element={<BathroomAtlasRoiPage />}
            />
            <Route
              path="/bathroom-cost-by-state/best-diy-friendly-states"
              element={<BathroomAtlasDiyPage />}
            />
            <Route
              path="/bathroom-cost-by-state/quick-resale-picks-by-region"
              element={<BathroomAtlasQuickResalePage />}
            />
            {/* Hardscape + Landscape atlases — same playbook, hub + 4 variants. */}
            <Route path="/hardscape-cost-by-state" element={<HardscapeAtlasPage />} />
            <Route path="/hardscape-cost-by-state/cheapest-for-first-time-buyers" element={<HardscapeAtlasCheapestPage />} />
            <Route path="/hardscape-cost-by-state/best-roi-by-state" element={<HardscapeAtlasRoiPage />} />
            <Route path="/hardscape-cost-by-state/best-diy-friendly-states" element={<HardscapeAtlasDiyPage />} />
            <Route path="/hardscape-cost-by-state/quick-resale-picks-by-region" element={<HardscapeAtlasQuickResalePage />} />
            <Route path="/landscape-cost-by-state" element={<LandscapeAtlasPage />} />
            <Route path="/landscape-cost-by-state/cheapest-for-first-time-buyers" element={<LandscapeAtlasCheapestPage />} />
            <Route path="/landscape-cost-by-state/best-roi-by-state" element={<LandscapeAtlasRoiPage />} />
            <Route path="/landscape-cost-by-state/best-diy-friendly-states" element={<LandscapeAtlasDiyPage />} />
            <Route path="/landscape-cost-by-state/quick-resale-picks-by-region" element={<LandscapeAtlasQuickResalePage />} />
            <Route path="/outdoor-living-by-state" element={<OutdoorLivingByStatePage />} />
            <Route path="/outdoor-renovation-estimator" element={<OutdoorRenovationEstimatorPage />} />
            <Route path="/indoor-renovation-estimator" element={<IndoorRenovationEstimatorPage />} />
            <Route path="/trending" element={<TrendingPage />} />
            <Route path="/trending-snapshots" element={<TrendingSnapshotIndexPage />} />
            <Route path="/trending-snapshots/:period" element={<TrendingSnapshotPage />} />
            <Route path="/photos/state-window-trends" element={<StateWindowGalleryPage />} />
            <Route path="/embed/cost-index" element={<EmbedCostIndexPage />} />
            <Route path="/embed/storm-damage-calculator" element={<EmbedStormDamageCalculatorPage />} />
            <Route path="/embed/diy-or-contractor-calculator" element={<EmbedDiyOrContractorCalculatorPage />} />
            <Route path="/embed/repair-or-replace-roof-calculator" element={<EmbedRepairOrReplaceCalculatorPage />} />
            <Route path="/embed/renovation-financing-calculator" element={<EmbedRenovationFinancingCalculatorPage />} />
            <Route path="/embed/quote-fairness-calculator" element={<EmbedQuoteFairnessCalculatorPage />} />
            <Route
              path="/embed/how-much-to-spend-fixing-up-before-listing-calculator"
              element={<EmbedPreListingSpendCalculatorPage />}
            />
            <Route path="/embed/contractor-dispute-calculator" element={<EmbedContractorDisputeCalculatorPage />} />
            <Route path="/embed/should-i-finish-my-basement-calculator" element={<EmbedBasementFinishCalculatorPage />} />
            <Route path="/embed/dwelling-coverage-calculator" element={<EmbedDwellingCoverageCalculatorPage />} />
            {/* Cost-calculator embeds — all share one component, driven by slug. */}
            <Route path="/embed/bathroom-remodel-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/kitchen-remodel-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/roofing-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/deck-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/flooring-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/pool-installation-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/basement-finishing-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/window-replacement-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/solar-panel-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/fence-installation-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/painting-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/hardscape-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/landscaping-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/door-replacement-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/hvac-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/furnace-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/insulation-cost-calculator" element={<EmbedCalculatorPage />} />
            <Route path="/embed/calculator/:slug" element={<EmbedCalculatorPage />} />
            <Route path="/embeds" element={<EmbedsIndexPage />} />
            <Route path="/embeds/energy-efficiency-bundle" element={<EnergyEfficiencyBundlePage />} />
            <Route path="/embeds/storm-recovery-bundle" element={<StormRecoveryBundlePage />} />
            <Route path="/embeds/pre-listing-renovation-bundle" element={<PreListingRenovationBundlePage />} />
            <Route path="/embeds/outdoor-living-bundle" element={<OutdoorLivingBundlePage />} />
            <Route path="/embeds/installed-on/:host" element={<EmbedsInstalledOnPage />} />
            <Route path="/embeds/:slug" element={<EmbedWidgetLandingPage />} />
            <Route path="/answers" element={<AnswersPage />} />
            <Route path="/answers/:calcSlug" element={<AnswersCalcHubPage />} />
            {/* Q&A library — hand-authored single-question pages with
                QAPage JSON-LD. Cited preferentially by AI-search crawlers. */}
            <Route path="/qa" element={<QaIndexPage />} />
            <Route path="/qa/:slug" element={<QaSinglePage />} />
            <Route path="/dataset/2026-renovation-cost-index" element={<DatasetPage />} />
            <Route path="/developers" element={<ApiPage />} />
            <Route path="/storm-recovery" element={<StormRecoveryPage />} />
            <Route path="/storm-damage-claim-calculator" element={<StormDamageClaimCalculatorPage />} />
            <Route path="/repair-or-replace-roof-calculator" element={<RoofRepairOrReplaceCalculatorPage />} />
            <Route path="/renovate-or-move-calculator" element={<RenovateOrMoveCalculatorPage />} />
            <Route path="/will-my-roof-claim-pay-out-calculator" element={<RoofClaimCalculatorPage />} />
            <Route path="/dwelling-coverage-calculator" element={<DwellingCoverageCalculatorPage />} />
            <Route path="/diy-or-contractor-calculator" element={<DiyOrContractorCalculatorPage />} />
            <Route path="/renovation-roi-calculator" element={<RenovationRoiCalculatorPage />} />
            <Route path="/renovation-financing-calculator" element={<RenovationFinancingCalculatorPage />} />
            <Route path="/home-equity-loan-calculator" element={<HomeEquityLoanCalculatorPage />} />
            <Route path="/home-equity-loan-calculator/:stateSlug" element={<HomeEquityLoanStatePage />} />
            <Route path="/quote-fairness-calculator" element={<QuoteFairnessCalculatorPage />} />
            <Route path="/quote-fairness-calculator/:slug" element={<QuoteFairnessStateProjectPage />} />
            <Route path="/contractor-quote-comparison" element={<QuoteComparisonPage />} />
            <Route path="/contractor-dispute-calculator" element={<ContractorDisputeCalculatorPage />} />
            <Route path="/should-i-finish-my-basement-calculator" element={<BasementFinishCalculatorPage />} />
            <Route path="/should-i-get-solar-calculator" element={<SolarReadinessCalculatorPage />} />
            <Route path="/state-utility-rebate-lookup" element={<RebateLookupPage />} />
            <Route path="/tools" element={<ToolsIndexPage />} />
            <Route path="/comfort-upgrade-estimator" element={<ComfortUpgradeEstimatorPage />} />
            <Route path="/tools/rebate-lookup/:stateSlug" element={<StateRebatePage />} />
            <Route path="/basement-finish-roi" element={<BasementFinishRoiHubPage />} />
            <Route path="/basement-finish-roi/state/:stateSlug" element={<BasementFinishRoiStateAggregatorPage />} />
            <Route path="/basement-finish-roi/:slug" element={<BasementFinishRoiStateProjectPage />} />
            <Route path="/best-low-permit-states-for-diy-remodelers" element={<LowPermitStatesPage />} />
            <Route path="/best-roi-basement-finish-states" element={<BestRoiBasementFinishStatesPage />} />
            <Route path="/best-roi-renovations-by-state" element={<BestRoiRenovationsByStatePage />} />
            <Route path="/decision-tools" element={<DecisionToolsHubPage />} />
            <Route path="/renovation-timeline" element={<RenovationTimelineHubPage />} />
            <Route path="/renovation-timeline/:slug" element={<RenovationTimelineStateProjectPage />} />
            <Route path="/contractor-licensing" element={<ContractorLicensingHubPage />} />
            <Route path="/contractor-licensing/:slug" element={<ContractorLicensingStateProjectPage />} />
            <Route path="/contractor-deposit-rules" element={<ContractorDepositRulesHubPage />} />
            <Route path="/contractor-deposit-rules/:slug" element={<ContractorDepositRulesStateProjectPage />} />
            <Route path="/energy-rebates" element={<EnergyRebatesHubPage />} />
            <Route path="/energy-rebates/:slug" element={<EnergyRebatesStateProjectPage />} />
            <Route path="/permit-cost" element={<PermitCostHubPage />} />
            <Route path="/permit-cost/:slug" element={<PermitCostStateProjectPage />} />
            <Route path="/state-overview" element={<StateOverviewHubPage />} />
            <Route path="/state-overview/:stateSlug" element={<StateOverviewPage />} />
            <Route path="/admin/heehra" element={<HeehraAdminPage />} />
            <Route path="/best-of-2026" element={<BestOf2026Page />} />
            <Route path="/roi-showdown" element={<RoiShowdownPage />} />
            <Route path="/pre-bid-scope-checklist" element={<PreBidScopeChecklistPage />} />
            <Route
              path="/how-much-to-spend-fixing-up-before-listing-calculator"
              element={<PreListingSpendCalculatorPage />}
            />
            <Route path="/whats-new" element={<WhatsNewPage />} />
            <Route path="/whats-new/:slug" element={<WhatsNewPage />} />
            {WHY_EXPENSIVE_ROUTES.map((r) => (
              <Route key={r.path} path={r.path} element={<WhyExpensivePage stateSlug={r.slug} />} />
            ))}
            <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </Layout>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
